<div class="container">
  <mat-spinner></mat-spinner>
  <span class="authenticating-text" i18n>Authentifizierung</span>
</div>
